<template>
    <div>
        <h1 style="font-size: 24px; color: black;">矩阵配置 </h1>
        <el-card class="form-container" style="margin-top: 25px" shadow="never">
            
            <el-row  type="flex"  align="middle" >
                <el-col :span="5">
                        <span > 游戏：</span>
                        <el-select v-model="queryData.games" multiple clearable filterable placeholder="请选择/输入">
                            <el-option
                                v-for="item in gameSelectorList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                </el-col>

                <el-col :span="5">
                        <span > 位置：</span>
                        <el-select v-model="queryData.positions" multiple clearable collapse-tags placeholder="请选择/输入">
                            <el-option
                                v-for="position in positions"
                                :label="position.name"
                                :key="position.id"
                                :value="position.id">
                            </el-option>
                        </el-select>
                </el-col>
            </el-row>
            <el-row  type="flex"  align="middle" >
                <el-col :span="5">
                        <span> 渠道： </span>
                        <el-cascader v-model="queryData.subChannels" :options="channelList" :props="optionProps" clearable
                                    collapse-tags>
                        </el-cascader>
                </el-col>
                    <el-col :span="5" style="margin-left:10px;" >
                    <el-button type="primary" @click="searchListMatch">查询</el-button>
                    <el-button  type="primary" @click="handleEdit('新增游戏匹配')">新增游戏</el-button>
                    <el-button  type="primary" @click="addNotInList">添加列表中没有的游戏</el-button>                
                </el-col>
            </el-row>
        </el-card>
        <div>
            <el-table
                border
                :fit="true"
                :row-class-name="tableRowClass"
                :data="rules">
                <el-table-column prop="id" label="矩阵ID"></el-table-column>
                <el-table-column prop="gameName" label="游戏名称"></el-table-column>
                <el-table-column prop="subChannels" label="绑定渠道"  :formatter="formatterChannels" width="300px" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column  prop="positions" label="位置" :formatter="formatterPositions" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="count" label="选品总数"></el-table-column>
                <el-table-column prop="modelFlag" label="使用模板" :formatter="formatterBoolean"></el-table-column>
                <el-table-column prop="modelId" label="模板id"></el-table-column>
                <el-table-column label="操作" align="center" width="300px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit('编辑游戏匹配',scope.row)">编辑</el-button>
                        <el-button size="mini" type="success" @click="showSelectorDialog(scope.row)">选品</el-button>
                        <el-button size="mini" type="warning" @click="copyRow(scope.row)">复制</el-button>
                        <el-button size="mini" type="info" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
        <el-pagination
            @size-change="handleTotalSizeChange"
            @current-change="handleTotalCurrentChange"
            :current-page="queryData.page"
            :page-sizes="[30,50,70,90,100]"
            :page-size="queryData.size"
            layout="total, sizes, prev, pager, next"
            :total="totalSize">
        </el-pagination>
    </div>
        <div>
            <el-dialog :title="editDialogTitle"
                       center
                       :visible.sync="editDialogVisible"
                       @close="editDialogVisible=false"
                       width="600px">
                <el-form :model="matchEditForm">
                    <el-form-item label="游戏名称" :label-width="labelWidth">
                        <el-select filterable placeholder="请选择"
                                   v-model="matchEditForm.gameId">
                            <el-option
                                v-for="item in gameSelectorList"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="版块位置" :label-width="labelWidth">
                        <template>
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                         @change="handleCheckAllChange">全选
                            </el-checkbox>
                            <div style="margin: 15px 0;"></div>
                            <el-checkbox-group v-model="matchEditForm.positionsList"
                                               @change="handleCheckedPositionsChange">
                                <el-checkbox v-for="position in positions" :label="position.id" :key="position.id">
                                    {{ position.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </template>
                    </el-form-item>
                    <el-form-item label="渠道选择" :label-width="labelWidth">
                        <el-cascader v-model="matchEditForm.subChannelList" :options="channelList" :props="optionProps"
                                     clearable collapse-tags placeholder="必须选择">
                        </el-cascader>
                    </el-form-item>
                    <h1>模板配置</h1>
                    <el-form-item label="使用模板" align="center" :label-width="labelWidth">
                        <el-switch v-model="matchEditForm.modelFlag"
                                    :active-value="true"
                                    :inactive-value="false"
                                    active-text="开启"
                                    inactive-text="关闭"
                                    >
                            </el-switch>
                    </el-form-item>
                    <!-- todo 需要调整样式位置偏移 -->
                   <el-form-item label="模板名称" v-if="matchEditForm.modelFlag" :label-width="labelWidth">
                        <el-select filterable placeholder="请选择"
                                   v-model="matchEditForm.modelId">
                            <el-option
                                v-for="item in allModelList"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <h1>排行榜配置</h1>
                    <el-card  shadow="never">
                        <el-form-item label="排行榜名称" :label-width="labelWidth">
                            <el-input
                                    placeholder="请输入内容"
                                    prefix-icon="el-icon-edit"
                                    maxlength="8"
                                    v-model="matchEditForm.rankingName">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="排行榜排序" :label-width="labelWidth">
                            <el-radio v-model="matchEditForm.rankingOrder" :label="0">从大到小</el-radio>
                            <el-radio v-model="matchEditForm.rankingOrder" :label="1">从小到大</el-radio>
                        </el-form-item>
                        <el-form-item label="排行榜单位" :label-width="labelWidth">
                            <el-radio v-model="matchEditForm.rankingUnit" :label="0">关卡</el-radio>
                            <el-radio v-model="matchEditForm.rankingUnit" :label="1">分数</el-radio>
                            <el-radio v-model="matchEditForm.rankingUnit" :label="2">时间</el-radio>
                            <!--<el-input
                                    placeholder="请输入内容"
                                    prefix-icon="el-icon-odometer"
                                    maxlength="3"
                                    v-model="matchEditForm.rankingUnit">
                            </el-input>-->
                        </el-form-item>
                        <el-form-item label="排行榜TOP" :label-width="labelWidth">
                            <el-input
                                    placeholder="请输入内容"
                                    prefix-icon="el-icon-medal-1"
                                    v-model="matchEditForm.rankingTopName">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="排行榜可用" :label-width="labelWidth">
                            <el-switch v-model="matchEditForm.rankingIsUse"
                                       :active-value="true"
                                       :inactive-value="false"
                                       active-text="开启"
                                       inactive-text="关闭">
                            </el-switch>
                        </el-form-item>
                    </el-card>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmEditFormDialog">确 定</el-button>
                        <el-button type="info" @click="editDialogVisible=false">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </div>
        <div>
            <el-dialog title="选品管理"
                       center
                       :visible.sync="selectorDialogVisible"
                       @open="matchInfo"
                       @close="selectorDialogVisible=false"
                       :close-on-click-modal="false"
                       :show-close="false"
                       :destroy-on-close="true"
                       width="1500px">
                <h4>当前游戏名称:<font size="6" bold>{{ plateInfo().gameName }}</font></h4>
                <div style="margin-bottom: 10px;">
                    <span>游戏名称：</span>
                    <el-select v-model="queryGameSelector.gameIds" multiple filterable placeholder="请选择/输入">
                        <el-option
                            v-for="item in gameSelectorList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <!-- 默认查询业务为208 -->
                    <span >业务类型：</span>
                    <el-select v-model="queryGameSelector.dept" clearable  placeholder="请选择/输入">
                                <el-option
                                        v-for="item in deptConst"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.value">
                                </el-option>
                    </el-select>
                    <span > 游戏标签：</span>
                    <el-cascader v-model="queryGameSelector.gameLabels" :options="labelList" :props="{ key:'id',value:'id', label:'name',multiple:true }" clearable collapse-tags></el-cascader>
                    <br>
                    <span>记录日期：</span>
                    <el-date-picker
                        v-model="searchDateRange"
                        type="daterange"
:clearable="false"
                        :picker-options="pickerOptions"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                    <span>渠道筛选：</span>
                    <el-cascader v-model="queryGameSelector.subChannelIds" :options="channelList" :props="optionProps"
                                 clearable collapse-tags>
                    </el-cascader>
                    <el-button type="primary" @click="queryGameList">查询</el-button>
                    <table>
                        <tr>
                            <td>
                                <el-button  type="primary" @click="clearAllSelected">一键清除</el-button>
                            </td>
                            <td>
                                <el-upload :action="upload()" :headers="headers"
                                           :on-success="handleSuccess"
                                           :before-upload="beforeUpload"
                                           :show-file-list="false"
                                           v-loading.fullscreen.lock="loading" :disabled="disable"
                                           ref="upload">
                                    <el-button size="medium" type="primary" :disabled="disable">导入</el-button>
                                    <span style="color:crimson">当前只能导入一次， 导入成功后如需重新导入请关闭页面后，再重新打开。</span>
                                </el-upload>
                            </td>
                        </tr>
                    </table>
                </div>
                <template>
                    <h4>选择游戏（最少4个)</h4>
                    <el-table border
                              ref="multipleTable"
                              :data="gameList"
                              :row-class-name="gameRowTableClass"
                              stripe
                              tooltip-effect="dark"
                              style="width: 100%"
                              :row-key="getRowKeys"
                              @selection-change="handleSelectionChange"
                              @sort-change="sort_change"
                              @filter-change="filterTagTable"
                    >
                        <el-table-column
                            type="selection"
                            :reserve-selection="true"
                            width="55">
                        </el-table-column>
                        <el-table-column
                            type="index"
                            label="编号"
                            width="50">
                        </el-table-column>
                        <el-table-column
                            label="游戏类型" align="center">
                            <el-table-column
                                prop="name"
                                label="游戏名称">
                            </el-table-column>
                            <el-table-column
                                    prop="dept"
                                    label="业务类型">
                            </el-table-column>
                            <el-table-column
                                    :formatter="formatGameLabels"
                                    :show-overflow-tooltip="true"
                                    prop="gameLabelNames"
                                    label="游戏标签">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                            prop="squareIcon"
                            label="大图标"
                            align="center"
                            :filters="[{ text: '有', value: 1  }, { text: '无', value: 0 }]"
                            :filter-multiple="false"
                            :column-key=" 'squareFlag' "
                        >
                            <template slot-scope="scope">
                                <el-tag type="success" v-if="scope.row.squareIcon && scope.row.squareIcon !=''">有
                                </el-tag>
                                <el-tag type="info" v-else>无</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="bannerIcon"
                            :column-key=" 'bannerFlag' "
                            label="banner"
                            align="center"
                            :filters="[{ text: '有', value: 1 }, { text: '无', value: 0 }]"
                            :filter-multiple="false"
                        >
                            <template slot-scope="scope">
                                <el-tag type="success" v-if="scope.row.bannerIcon && scope.row.bannerIcon !=''">有
                                </el-tag>
                                <el-tag type="info" v-else>无</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="microVideo"
                            :column-key=" 'videoFlag' "
                            label="视频"
                            align="center"
                            :filters="[{ text: '有', value: 1 }, { text: '无', value: 0 }]"
                            :filter-multiple="false"
                        >
                            <template slot-scope="scope">
                                <el-tag type="success" v-if="scope.row.microVideo && scope.row.microVideo !=''">有
                                </el-tag>
                                <el-tag type="info" v-else>无</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="吸量" align="center">
                            <el-table-column prop="avgUserClickPoint" sortable="custom" label="平均用户点击率"
                                             :formatter="formatterPercent">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="活跃" align="center">
                            <el-table-column prop="avgDayAliveUserPercent" sortable="custom" label="平均日活用户">
                            </el-table-column>
                            <el-table-column sortable="custom" prop="sumActivityUserCount" label="累计活跃用户">
                            </el-table-column>
                            <el-table-column sortable="custom" prop="sumPlayCount" label="累计游戏频次">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="质量" align="center">
                            <el-table-column sortable="custom" prop="avgPersonPlayCount" label="人均游戏频次">
                            </el-table-column>
                            <el-table-column sortable="custom" prop="avgPersonPlayDuration" label="人均游戏时长">
                            </el-table-column>
                            <el-table-column sortable="custom" prop="avgSecondaryPercent" label="平均次日留存率"
                                             :formatter="formatterPercent">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="新品" align="center">
                            <el-table-column sortable="custom" prop="dtCreate" :formatter="formatDate" label="游戏发布时间">
                            </el-table-column>
                            <el-table-column sortable="custom" prop="dtUpdate" :formatter="formatDate" label="游戏更新时间">
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                    <div>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryGameSelector.page"
                            :page-sizes="[5, 10,30,50,70,90,100]"
                            :page-size="queryGameSelector.size"
                            layout="total, sizes, prev, pager, next"
                            :total="totalElements">
                        </el-pagination>
                    </div>
                </template>
                <template v-if="selectedGameList.length>0">
                    <h4>已经选择的游戏</h4>
                    <el-table border
                              :data="selectedGameList"
                              tooltip-effect="dark"
                              style="width: 100%">
                        <el-table-column
                            type="index"
                            label="编号"
                            width="50">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="游戏名称">
                        </el-table-column>
                        <el-table-column
                                    :formatter="formatGameLabels"
                                    :show-overflow-tooltip="true"
                                    prop="gameLabelNames"
                                    label="游戏标签">
                            </el-table-column>
                        <el-table-column label="标签" align="center">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.label" placeholder="请选择">
                                    <el-option @change="disable=true"
                                        v-for="item in labels"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="特效" align="center" width="150px">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.highLight" @change="disable=true"
                                           :active-value="1"
                                           :inactive-value="0"
                                           active-text="有"
                                           inactive-text="无"
                                >
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column label="排序" align="center">
                            <template slot-scope="scope">
                                <el-input-number size="mini" v-model="scope.row.rank" @change="disable=true"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="maxPlaying"
                            label="最大在玩人数"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="minPlaying"
                            label="最小在玩人数"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger"
                                           @click.native.prevent="deleteRow(scope.$index, scope.row)">移除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <el-form>
                    <el-form-item>
                        <template>
                            <div class="block">
                                <h4>设置生效时间:
                                    <el-date-picker
                                        v-model="useTime"
                                        type="datetime"
                                        placeholder="选择日期时间"
                                    >
                                    </el-date-picker>
                                </h4>
                            </div>
                        </template>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmAddSelect(selectedGameList,matchInfo().id,useTime)">确
                            定
                        </el-button>
                        <el-button type="info" @click="closeSelectorFormDialog()">返 回</el-button>
                    </div>
                </el-form>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import {
    addMatchGame,
    addNotInList,
    allIndexStyles,
    allLabels,
    batchMatchAdd,
    channelList,
    deleteMatchGame,
    editMatchGame,
    // gameList,
    gameMatchCopy,
    // gameMatchList,
    gameMatchSelectorSearch,
    listMatchSelector,
    searchGameMatch,
    gameRunningList,
    allSimpleModelList,
    allGameLabels
} from "@/http/api";
import utils from '@/utils'

export default {
    name: "MatrixConfig",
    data() {
        return {
            disable:false,
            headers: {},
            loading: false,
            VUE_APP_BASE_URL:null,
            checkAll: false,
            isIndeterminate: true,
            labelWidth: '100px',
            editDialogVisible: false,
            selectorDialogVisible: false,
            editDialogTitle: '',
            //模块编辑的数据对象
            matchEditForm: {
                "id": 0,
                "gameId": "",
                "rankingName":"",
                "rankingOrder":0,
                "rankingUnit":0,
                "rankingTopName":"",
                "rankingIsUse":true,
                "positions": [],
                "subChannels": [],
                "positionsList": [],
                "subChannelList": [],
                "modelFlag":false,
                "modelId":""
            },
            optionProps: {
                emitPath: false,
                multiple: true,
                value: 'subChannel',
                label: 'name',
                children: 'children',
            },
            //版块列表数据
            rules: [],
            //位置版块
            positions: [],
            //位置ID集合
            positionIds: [],
            //位置名称
            positionNames: [],
            //游戏列表
            gameList: [],
            //每行板块
            rule: {},
            //最终选中的列表
            selectedGameList: [],
            //临时新增展示的列表
            tempSelectedGameList: [],
            //判断是否进行监听selectedGameList 标志位
            flag: false,
            queryGameData: {
                name: ''
            },
            subQueryData: {},
            //设置当前页面总数
            totalSize: 0,
            queryData: {
                games: [],
                positions: [],
                subChannels: [],
                size: 30,
                page: 1
            },
            games: [],
            channelList: [],
            //子渠道集合
            subChannelList: [],
            //子渠道号集合
            subChannels: [],
            //子渠道名称集合
            subChannelNames: [],
            //生效时间
            useTime: '',
            //LinkedIds:new Set(),
            labels: [],
            //游戏选品中游戏列表下拉框数据 固定的
            gameSelectorList: [],
            // 游戏选品
            queryGameSelector: {
                "gameIds": [],
                "gameLabelIds": [],
                "gameLabels": [],
                "state": 1,
                "startTime": '',
                "endTime": '',
                "subChannelIds": [],
                "prop": '',
                "order": '',
                "page": 1,
                "size": 10,
                "dept":''
            },
            //游戏选品总数
            totalElements: 0,
            //查询日期区间
            searchDateRange: [],
            pickerMinDate: '',
            pickerOptions: {
                onPick: (time) => {
                    // this.pickerMinDate = time.minDate;
                    if (time.minDate && !time.maxDate) {
                        this.pickerMinDate = time.minDate;  //将第一次选中值保存
                    }
                    if (time.maxDate) {
                        this.pickerMinDate = null;
                    }
                },
                disabledDate: (time) => {
                    if (this.pickerMinDate) {
                        const day1 = 7 * 24 * 3600 * 1000;
                        let maxTime = this.pickerMinDate.getTime() + day1;
                        let minTime = this.pickerMinDate.getTime() - day1;
                        return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() + 24 * 3600 * 1000
                    } else {
                        return time.getTime() > Date.now() + 24 * 3600 * 1000
                    }
                }
            },
            allModelList:[],
            // 业务组常量 目前写死 
            deptConst:[{id:0,name:'全部',value:null},
                {id:1,name:'208',value:"208"},
                {id:2,name:'211',value:"211"}],
            // 游戏标签
                labelList:[],
        }
    },
    methods: {

        formatterPercent: function (row, column, cellValue) {
            return cellValue + "%";
        },
        
        formatterChannels: function (row, column, cellValue) {
            var res = ""
            var subChannelTemp = this.subChannelList; 
            if(cellValue === null ){
                    return res;
            } 
            var myarray = cellValue.split(","); 
            myarray.forEach(function(item){
                // 这里需要使用 == 不能使用 === 
                var findSubChannel =subChannelTemp.find(a => a.subChannel === item); 
                if(findSubChannel !== null && findSubChannel !== undefined){
                    
                    res= res + " | "+ findSubChannel['name'];
                }
                
          });
            return  res;
        },
        
        formatterPositions: function (row, column, cellValue) { 
            var res = ""
            var positionsTemp = this.positions;
            if(cellValue === null ){
                    return res;
            } 
            var myarray = cellValue.split(","); 
            myarray.forEach(function(item){
                // 这里需要使用 == 不能使用 === 
                var findPosition =positionsTemp.find(position => position.id == item); 
                if(findPosition !== null && findPosition !== undefined){
                    res= res + " | "+ findPosition['name'];
                }
          });
            return  res;
        },
        formatterBoolean: function (row, column, cellValue) { 
            // console.log(cellValue)
            if(cellValue === null ){
                    return "否";
            } 
            if(cellValue==1 || cellValue==true){
                return "是"
            }else{
                return "否"
            }
        },
        formatGameLabels: function(row, column, cellValue) {
                var name="无";
                if(cellValue!=null && cellValue.length>0){
                   return  cellValue  ;
                } 
                return name;
            },
        handleEdit: function (title, row) {
            this.matchEditForm = {
                "id": 0,
                "gameId": "",
                "rankingName":"",
                "rankingOrder":0,
                "rankingUnit":0,
                "rankingTopName":"",
                "rankingIsUse":true,
                "positions": [],
                "subChannels": [],
                "positionsList": [],
                "subChannelList": [],
                "modelFlag":false,
                "modelId":""
            };

            this.editDialogTitle = title;
            this.editDialogVisible = true;

            if (row) {
                var tempPosition = [];
                var tempChannel = [];
                // 这里用split切分并且用 tempPosition.map(Number);  转换失败并不能把数组转换为int数组  用这个tempPosition = tempPosition.map(item => +item);就可以
                // tempPosition = JSON.parse('[' + row.positions + ']') 
                if(row.subChannels !==undefined && row.subChannels !==null){
                    tempChannel = row.subChannels.split(","); 
                }
                if(row.positions !==undefined && row.positions !==null){
                    tempPosition = row.positions.split(","); 
                    tempPosition = tempPosition.map(item => +item);
                }
                
                this.matchEditForm = {
                    "id": row.id,
                    "gameId": row.gameId,
                    "rankingName":row.rankingName,
                    "rankingOrder":row.rankingOrder,
                    "rankingUnit":row.rankingUnit,
                    "rankingTopName":row.rankingTopName,
                    "rankingIsUse":row.rankingIsUse,
                    "positions": [],
                    "subChannels": [],
                    "positionsList": tempPosition,
                    "subChannelList": tempChannel,
                    "modelFlag":row.modelFlag,
                    "modelId":row.modelId
                };
            }
        },
        handleDelete: function (row) {
            this.$confirm('确认是否删除?', '警告', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteMatchGame(row.id).then(resp => {
                    if (resp.data.status === 0) {
                        this.searchListMatch();
                    }
                })
            }).catch(() => {
            })
        },
        gameRowTableClass({row, rowIndex}) {
            row.index = rowIndex
        },
        getRowKeys(row) {
            return row.id
        },
        matchInfo: function () {
            return this.rule;
        },
        searchListMatch: function () {
            searchGameMatch(this.queryData).then(resp => {
                this.rules = resp.data.info.content;
                //设置总条数
                this.totalSize = resp.data.info.totalElements;

            })
        },
        showSelectorDialog: function (row) {
            this.disable=false;
            this.selectorDialogVisible = true;
            this.rule = row;
            this.queryGameSelector = {
                "gameIds": [],
                "gameLabels":[],
                "gameLabelIds":[],
                "state": 1,
                "startTime": '',
                "endTime": '',
                "subChannelIds": [],
                "prop": '',
                "order": '',
                "page": 1,
                "size": 10,
                "squareFlag": -1,
                "bannerFlag": -1,
                "videoFlag": -1,
                "dept":"208"
            },
                //展示前清空临时已选游戏列表
                this.tempSelectedGameList = [];
            this.selectedGameList = [];
            //=========================================================初始化已选游戏列表
            //获取已选择的游戏信息 传入
            //console.log(this.rule.id);
            listMatchSelector(this.rule.id).then(resp => {
                //设置临时已经选择的list
                if (resp.data.info) {
                    resp.data.info.forEach((info) => {
                        //这里查询获取到的已经选择游戏
                        this.selectedGameList.push(info.game)
                    });
                }
                //调用通用数据处理方法
                this.gameSelectorTemp();
            });
            //设置生效日期
            this.useTime = new Date(row.validDate);
            this.headers = {Authorization: this.$store.state.user.token};
        },
        confirmAddSelect(preList) {
            //console.log(preList)
            let _this = this;
            let gameSelectors = [];
            let obj = {};
            //构造新的游戏选品list 传给后台
            gameSelectors= preList.reduce((cur, next) => {
                        obj[next.id] ? "" : (obj[next.id] = true && cur.push(
                            {game:{id:next.id},
                                rank:next.rank,
                                label:next.label,
                                highLight:next.highLight}));
                        return cur;
                    }, []); 
            //这里 改成传入  在后台进行已有数据清空
            batchMatchAdd(_this.matchInfo().id, gameSelectors).then(resp => {
                if (resp.data.status === 0) {
                    _this.searchListMatch();
                }
            }).catch(function () {
            });
            //调用关闭dialog接口
            this.closeSelectorFormDialog();
        },
        deleteRow(index, row) {
            this.disable=true
            this.selectedGameList.splice(index, 1);
            this.gameList.forEach(item => {
                if (item.id === row.id) {
                    this.$refs.multipleTable.toggleRowSelection(item, false);
                    this.tempSelectedGameList.forEach((game, index) => {
                        //如果删除的是临时的游戏选品 而不是已经选好的 需要清除对应templist
                        if (game.id === row.id) this.tempSelectedGameList.splice(index, 1)
                    })
                }
            })
        },

        tableRowClass: function (row) {
            if (row.rowIndex % 2 === 1) {
                return 'row_odd_class'
            }
            return ''
        },

        copyRow(row) {
            console.log(row)
            gameMatchCopy(row.id).then(resp => {
                if (resp.data.status === 0) {
                    this.searchListMatch();
                }
            })
        },
        confirmEditFormDialog: function () {
            let _message = '';
            if (this.matchEditForm.gameId === '') {
                _message = '请选择游戏'
            } else if (this.matchEditForm.positionsList.length < 1) {
                _message = '请选择位置'
            }
            // console.log(this.matchEditForm)
            if(this.matchEditForm.modelFlag == false &&  this.matchEditForm.modelId!=null ){
                _message = '请打开模板开关'
            }
            if(this.matchEditForm.modelFlag== true &&  this.matchEditForm.modelId==null  ){
                _message = '请选择模板信息'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }
            var tempPosition = [];
            var tempChannel = [];
            this.matchEditForm.positionsList.forEach(p => {
                tempPosition.push({position: p})
            })
            this.matchEditForm.subChannelList.forEach(c => {
                tempChannel.push({channel: {subChannel: c}})
            })
            this.matchEditForm.positions = tempPosition;
            this.matchEditForm.subChannels = tempChannel;
            if (this.matchEditForm.id === 0) {
                addMatchGame(this.matchEditForm).then(resp => {
                    if (resp.data.status === 0) {
                        this.editDialogVisible = false;
                        this.searchListMatch();
                    }
                });
            } else {
                editMatchGame(this.matchEditForm).then(resp => {
                    if (resp.data.status === 0) {
                        this.editDialogVisible = false;
                        this.searchListMatch();
                    }
                });
            }

        },
        handleSelectionChange(val) {
            this.disable = true;
            let _this = this;
            //console.log('select', val)
            val.forEach(function (game) {
                //设置默认值
                _this.$set(game, 'rank', 0);
                _this.$set(game, 'label', 0);
                _this.$set(game, 'highLight', 0);
                _this.selectedGameList.forEach(function (gameSelector) {
                    if (game.id === gameSelector.id) {
                        _this.$set(game, 'rank', gameSelector.rank);
                        _this.$set(game, 'label', gameSelector.label)
                        _this.$set(game, 'highLight', gameSelector.highLight)
                    }
                })
            });
            _this.tempSelectedGameList = val
        },
        gameSelectorTemp() {
            //这个flag是设置watch监听事件 当跟新完当前页已选游戏标志位后再下一次渲染中设置为true
            this.flag = false
            //重要 这里是element分页的一个bug 在分页情况下切换已勾选页会重复添加已勾选数据 所以在这里清除全部勾选
            ;this.gameList.forEach(item => {
                this.$refs.multipleTable.toggleRowSelection(item, false);
            });
            let newLabelIds =[];// eslint-disable-line no-unused-vars
                 this.queryGameSelector.gameLabels.forEach(function (category) {
                      category.forEach(function (sub,index) {
                         if(index%2!==0){
                             newLabelIds.push(sub);
                         }
                      })
                 });
            this.queryGameSelector.gameLabelIds=newLabelIds;
            gameMatchSelectorSearch(this.queryGameSelector).then(resp => {
                this.gameList = resp.data.info.content;
                this.totalElements = resp.data.info.totalElements;
                //获取已选中游戏id
                const ids = [];
                this.selectedGameList.length && this.selectedGameList.forEach(item => {
                    ids.push(item.id)
                });
                //临时temp数组
                const tempSelectedGameList = [];
                //console.log('xxxx', ids)
                //判断当前页是否有已选中游戏 如果有设置已勾选
                ids.length && this.gameList.forEach(item => {
                    if (ids.indexOf(item.id) > -1) {
                        tempSelectedGameList.push(item);
                        this.$refs.multipleTable.toggleRowSelection(item, true);
                    }
                });
                this.disable=false;
                //console.log('new page: ', tempSelectedGameList)
                //赋值
                this.tempSelectedGameList = tempSelectedGameList;
                //渲染 并设置flag为true
                this.$nextTick(() => this.flag = true)
            });
        },
        sort_change(column) {
            this.queryGameSelector.page = 1;
            //如果列空则条件清空  如果order为null手动置为空字符串 如果其他情况设置字段
            if (column.prop == null) {
                this.queryGameSelector.prop = "";
                this.queryGameSelector.order = ""
            } else {
                if (column.order == null) {
                    this.queryGameSelector.order = ""
                } else {
                    this.queryGameSelector.order = column.order
                }
                this.queryGameSelector.prop = column.prop
            }
            this.gameSelectorTemp()
        },
        closeSelectorFormDialog: function () {
            this.selectedGameList = [];
            this.tempSelectedGameList = [];
            this.selectorDialogVisible = false;
        },
        handleSizeChange(newSize) {
            this.queryGameSelector.size = newSize;
            this.gameSelectorTemp()
        },
        handleCurrentChange(newPage) {
            this.queryGameSelector.page = newPage;
            this.gameSelectorTemp()
        },
        // 总条数修改
        handleTotalSizeChange(newSize) {
            this.queryData.size = newSize;
            this.searchListMatch();
        },
        //总页数跳转
        handleTotalCurrentChange(newPage) {
            this.queryData.page = newPage;
            this.searchListMatch();
        },
        formatDate: function (row, column) {
            return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
        },
        filterTagTable(filters) {
            if (filters.squareFlag) {
                //设置大图标标志位
                this.queryGameSelector.squareFlag = filters.squareFlag[0]
            } else {
                this.queryGameSelector.squareFlag = -1
            }
            if (filters.bannerFlag) {
                //设置banner 标志位
                this.queryGameSelector.bannerFlag = filters.bannerFlag[0]
            } else {
                this.queryGameSelector.bannerFlag = -1
            }
            if (filters.videoFlag) {
                //设置videoFlag
                this.queryGameSelector.videoFlag = filters.videoFlag[0]
            } else {
                this.queryGameSelector.videoFlag = -1
            }
            this.gameSelectorTemp() // 筛选所选项下的所有数据，需要调用后端接口
        },
        queryGameList() {
            if (this.searchDateRange && this.searchDateRange[0] && this.searchDateRange[1]) {
                this.queryGameSelector.startTime = this.searchDateRange[0];
                this.queryGameSelector.endTime = this.searchDateRange[1]
            } else {
                this.queryGameSelector.startTime = '';
                this.queryGameSelector.endTime = ''
            }
            //todo  判断排序 页数置1
            this.queryGameSelector.page = 1;
            this.gameSelectorTemp()
        },

        handleCheckAllChange(val) {
            this.matchEditForm.positionsList = val ? this.positionIds : [];
            this.isIndeterminate = false;
        },
        handleCheckedPositionsChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.positions.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.positions.length;
        },
        plateInfo() {
            return this.rule;
        },
        clearAllSelected() {
            //清除全部已选游戏
            //这个flag是设置watch监听事件 当跟新完当前页已选游戏标志位后再下一次渲染中设置为true
            // this.flag = false
            //重要 这里是element分页的一个bug 在分页情况下切换已勾选页会重复添加已勾选数据 所以在这里清除全部勾选
            // this.gameList.forEach(item => {
            //     this.$refs.multipleTable.toggleRowSelection(item,false);
            // })
            this.$refs.multipleTable.clearSelection();
            this.selectedGameList = [];
            this.tempSelectedGameList = [];
            this.disable=true;
            // this.flag=true;
        },
        handleSuccess(data){
            console.log(data);
            this.selectorDialogVisible=true;
            this.queryGameSelector={
                "gameIds": [],
                "gameLabelIds": [],
                "state": 1,
                "startTime": '',
                "endTime": '',
                "subChannelIds": [],
                "prop": '',
                "order": '',
                "page": 1,
                "size": 10,
                "squareFlag" : -1,
                "bannerFlag" : -1,
                "videoFlag" : -1,
                "dept":''
            };
            //展示前清空临时已选游戏列表
            this.tempSelectedGameList=[];
            this.selectedGameList=[];
            //=========================================================初始化已选游戏列表
            //获取已选择的游戏信息 传入

            if (data.info){
                data.info.forEach((info)=>{
                    //这里查询获取到的已经选择游戏
                    this.selectedGameList.push(info.game)
                });
            }
            //调用通用数据处理方法
            this.gameSelectorTemp();
            //设置生效日期
            this.useTime=new Date(this.rule.validDate);
            this.headers = {Authorization: this.$store.state.user.token};
            this.disable=true;
        },
        beforeUpload(data){
            console.log(data);
        },
        upload() {
            return this.VUE_APP_BASE_URL + '/gameMatch/selector/list/excel/'+this.rule.id;
        },
        addNotInList() {
            addNotInList().then(resp => {
                if (resp.data.status === 0) {
                    location.reload();
                } else {
                    this.$message.error('执行失败');
                }
            })
        }
    },
    mounted() {
        this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
    },
    watch: {

        tempSelectedGameList: {
            handler(val, oldVal) {
                //console.log('tempSelectedGameList', val, oldVal)
                //如果是加载数据阶段设置勾选时 不进行监听直接返回
                if (!this.flag) return;
                //新增数据判断
                const isAdd = val.length > oldVal.length;
                const oldArr = [], arr = [];
                oldVal.forEach((item) => {
                    oldArr.push(item.id)
                });
                val.forEach((item) => {
                    arr.push(item.id)
                });
                //console.log('arr', oldArr, arr)
                if (isAdd) {
                    let result = [];
                    arr.forEach(id => {
                        //把新增的数据项push进结果中 result
                        if (oldArr.indexOf(id) === -1) {
                            result.push(id)
                        }
                    });
                    result.forEach(id => {
                        //新数据中如果 id为新增数据项已经初始化之后了ranklabel 则添加到selectedGameList最终结果中
                        val.forEach((item) => {
                            if (item.id === id) this.selectedGameList.push(item)
                        })
                    })
                } else {
                    //删除时
                    let result = [];
                    oldArr.forEach(id => {
                        //把删除的id找出来
                        if (arr.indexOf(id) === -1) {
                            result.push(id)
                        }
                    });
                    //把selectedGameList中对应resultId 删除
                    result.forEach(id => {
                        this.selectedGameList.forEach((item, index) => {
                            if (item.id === id) this.selectedGameList.splice(index, 1)
                        })
                    })
                }
            }
        },
    },
    created() {
        allIndexStyles().then(resp => {
            let _this = this;
            this.positions = resp.data.info.filter(style => style.id === 5)[0].plateStyles;
            this.positions.forEach(function (position) {
                _this.positionIds.push(position.id);
            })

        });
        // 获取游戏标签
        allGameLabels().then(resp=>{
            this.labelList=resp.data.info;
        })
        allLabels().then(resp => {
            this.labels = resp.data.info;
        });
        channelList().then(resp => {
            let _this = this;
            this.channelList = JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                if (channel.children) {
                    channel.children = channel.children.filter(sub => sub.state === 1)
                }
                return channel;
            }).filter(channel => channel.children && channel.children.length);
            this.channelList.forEach(function (channel) {
                _this.$set(channel, 'subChannel', channel.id);
                channel.children.forEach(function (sub) {
                    _this.subChannelList.push(sub);
                    _this.subChannels.push(sub.subChannel);
                })
            });
        });
        gameRunningList().then(resp => {
            this.gameSelectorList = resp.data.info;
        });
        allSimpleModelList().then(resp => {
            this.allModelList=resp.data.info;
        })
        this.searchListMatch();
    },
}
</script>

<style lang="less">
.el-tooltip__popper{ max-width:50% }
</style>
